module.exports = __webpack_public_path__ + "img/arrow-right.d4281e53.svg";